import { userService } from "@/_services/supplier/user.service.js";
import moment from "moment";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { hotelService } from "@/_services/supplier/hotel.service.js";
import { CoolSelect } from 'vue-cool-select';

export default {
    name: 'user',
    components: {
        Treeselect,
        CoolSelect
    },
    data() {
        return {
            users: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 15, 20],
            filter: null,
            filterOn: ['username', 'fullName'],
            user: {},
            isCreate: false,
            isEdit: false,
            data: {
                username: null,
                fullName: null,
                email: null,
                active: true,
                gender: 1,
                phone: null,
                position: null,
                address: null,
            },
            OptionsHotel: [],
            OptionsSite: [],
            selectHotels: null,
            selectSites: null,
            selectedHotelGroup: 0,
            selectedSiteGroup: 0,
            sites: [],
            itemsKeyHotel: [],
            selectedHotel: null,
            loadingHotel: false,
            noData: false,
            itemsKeySite: [],
            selectedSite: null,
            loadingSite: false,
            noDataSite: false,
            hotels: [],
        };
    },
    created() {
        let currentUser = JSON.parse(localStorage.getItem("userInfo"));
        this.user = currentUser.user;
        this.getAllUser();
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        formatDate(i) {
            return moment(i).format('DD/MM/YYYY HH:mm:ss')
        },
        getAllUser() {
            userService.getList().then(
                response => {
                    if (response.responseCode === 0) {
                        this.users = response.data;
                    } else {
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                    this.totalRows = this.users.length;
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        editUser(user) {
            userService.detail(user.username).then(
                response => {
                    if (response.responseCode === 0) {
                        this.data = response.data;
                        // this.selectHotels = [];
                        // const arr = this.data.hotelIds ? this.data.hotelIds.split(",").map(x => +x) : [];
                        // this.OptionsHotel.forEach(element => {
                        //     if (arr.includes(element.id)) {
                        //         this.selectHotels.push(element);
                        //     }
                        // });
                        // this.selectSites = [];
                        // const arr1 = this.data.siteIds ? this.data.siteIds.split(",").map(x => +x) : [];
                        // this.OptionsSite.forEach(element => {
                        //     if (arr1.includes(element.id)) {
                        //         this.selectSites.push(element);
                        //     }
                        // });
                        this.callAPISite(user);
                        this.callAPIHotel(user);
                        this.isEdit = true;
                    } else {
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        callAPISite(user) {
            userService.getSiteUser(this.$i18n.locale, user.username).then(
                response => {
                    if (response.responseCode === 0) {
                        this.sites = response.data.sites;
                        if (response.data.sites === null) {
                            this.selectedSiteGroup = 0;
                        } else {
                            this.selectedSiteGroup = 1;
                        }
                    } else {
                        this.sites = [];
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                    this.totalRowsSite = this.sites.length;
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        callAPIHotel(user) {
            userService.getHotelUser(this.$i18n.locale, user.username).then(
                response => {
                    if (response.responseCode === 0) {
                        this.hotels = response.data.hotels;
                        if (response.data.hotels === null) {
                            this.selectedHotelGroup = 0;
                        } else {
                            this.selectedHotelGroup = 1;
                        }
                    } else {
                        this.hotels = [];
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                    this.totalRowsHotel = this.hotels.length;
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        onSearchHotel(search) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.noData = false;
                this.loadingHotel = true;
                const body = {
                    lang: this.$i18n.locale,
                    value: search,
                    types: ['HOTEL_NAME', 'HOTEL_ID'],
                    limit: 5,
                    offset: 0,
                };
                hotelService.getHotel(body).then(
                    response => {
                        const listRes1 =
                            typeof response.data.sites !== 'undefined' && Array.isArray(response.data.sites) ?
                                response.data.sites : [];
                        if (listRes1.length > 0) {
                            this.itemsKeyHotel = listRes1;
                        }
                        if (this.itemsKeyHotel.length <= 0) this.noData = true;
                        this.loadingHotel = false;
                    },
                    error => {
                        this.noData = true;
                        this.loadingHotel = false;
                        if (error.status === 403) {
                            this.showAlertLogout();
                        }
                    },
                );
            }, 500);
        },
        onSearchSite(search) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.noDataSite = false;
                this.loadingSite = true;
                const body = {
                    lang: this.$i18n.locale,
                    value: search,
                    types: ['HOTEL_NAME', 'HOTEL_ID'],
                    limit: 5,
                    offset: 0,
                };
                hotelService.getSite(body).then(
                    response => {
                        const listRes1 =
                            typeof response.data.sites !== 'undefined' && Array.isArray(response.data.sites) ?
                                response.data.sites : [];
                        if (listRes1.length > 0) {
                            this.itemsKeySite = listRes1;
                        }
                        if (this.itemsKeySite.length <= 0) this.noDataSite = true;
                        this.loadingSite = false;
                    },
                    error => {
                        this.noDataSite = true;
                        this.loadingSite = false;
                        if (error.status === 403) {
                            this.showAlertLogout();
                        }
                    },
                );
            }, 500);
        },
        addToList(value) {
            if (value === 'HOTEL') {
                if (this.hotels && this.hotels.length > 0) {
                    if (this.hotels.filter(e => e.hotelId === this.selectedHotel.hotelId).length === 0) {
                        this.hotels.push(this.selectedHotel);
                    }
                } else {
                    this.hotels = [];
                    this.hotels.push(this.selectedHotel);
                }
            } else {
                if (this.sites && this.sites.length > 0) {
                    if (this.sites.filter(e => e.hotelId === this.selectedSite.hotelId).length === 0) {
                        this.sites.push(this.selectedSite);
                    }
                } else {
                    this.sites = [];
                    this.sites.push(this.selectedSite);
                }
            }
        },
        createUser() {
            this.data = {
                username: null,
                fullName: null,
                email: null,
                active: true,
                gender: 1,
                phone: null,
                position: null,
                address: null,
            };

            this.sites = [];
            this.hotels = [];
            this.selectedHotelGroup = 0;
            this.selectedSiteGroup = 0;
            this.selectSites = null;
            this.selectHotels = null;
            this.isCreate = true;
        },
        back() {
            this.isEdit = false;
            this.isCreate = false;
        },
        onSubmit(event) {
            event.preventDefault();
            this.selectedSite = null;
            this.selectedHotel = null;
            const body = {
                username: this.data.username,
                fullName: this.data.fullName,
                email: this.data.email,
                active: this.data.active,
                gender: this.data.gender,
                phone: this.data.phone,
                position: this.data.position,
                address: this.data.address,
                hotelIds: this.selectedHotelGroup === 0 ? null : this.hotelIdsString,
                siteIds: this.selectedSiteGroup === 0 ? null : this.sitesString,
            };
            if (this.isEdit) {
                userService.update(body).then(
                    response => {
                        if (response.responseCode === 0) {
                            this.$bvToast.toast(this.$t('UPDATE_SUCCESS'), {
                                title: this.$t('NOTIFICATION'),
                                variant: 'success',
                                solid: true,
                                autoHideDelay: 1500,
                            });
                            this.getAllUser();
                            this.isEdit = false;
                            this.isCreate = false;
                        } else {
                            this.$bvToast.toast(this.$t(response.data), {
                                title: this.$t('NOTIFICATION'),
                                variant: 'warning',
                                solid: true,
                                autoHideDelay: 1500,
                            });
                        }
                    },
                    error => {
                        if (error.status === 403) {
                            this.showAlertLogout();
                        }
                    },
                );
            } else {
                userService.create(body).then(
                    response => {
                        if (response.responseCode === 0) {
                            this.$bvToast.toast(this.$t('CREATE_SUCCESS'), {
                                title: this.$t('NOTIFICATION'),
                                variant: 'success',
                                solid: true,
                                autoHideDelay: 1500,
                            });
                            this.getAllUser();
                            this.isEdit = false;
                            this.isCreate = false;
                        } else {
                            this.$bvToast.toast(this.$t(response.data), {
                                title: this.$t('NOTIFICATION'),
                                variant: 'warning',
                                solid: true,
                                autoHideDelay: 1500,
                            });
                        }
                    },
                    error => {
                        if (error.status === 403) {
                            this.showAlertLogout();
                        }
                    },
                );
            }
        },
        removeItem(data, index) {
            data.splice(index, 1);
        },
        remove(user) {
            const titleVNode = this.$createElement('div', { domProps: { innerHTML: `${this.$t('PLEASE_CONFIRM_YOU_WANT_TO_STOP_WORKING_WITH_USERS')} <b>${user.fullName}</b>` } });
            this.$bvModal.msgBoxConfirm([titleVNode], {
                title: this.$t('PLEASE_CONFIRM'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.$t('CONFIRM'),
                cancelTitle: this.$t('_LOGIN.CANCEL'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        userService.remove(user.username)
                            .then(response => {
                                if (response.responseCode === 0) {
                                    this.getAllUser();
                                }
                            });
                    }
                })
                .catch(err => {
                    // An error occurred
                });
        }
    },
    computed: {
        fieldsHotel() {
            return [
                { key: 'hotelId', label: this.$t('HOTEL_CODE'), sortable: true, },
                { key: 'name', label: this.$t('HOTEL_NAME'), sortable: true, },
                { key: 'address', label: this.$t('ADDRESS'), sortable: true, },
                { key: 'status', label: this.$t('_LIST_USER.STATUS'), sortable: true, },
                { key: 'actions', label: this.$t('_LIST_USER.ACTION'), class: 'text-right' },
            ];
        },
        fieldsSite() {
            return [
                { key: 'hotelId', label: this.$t('PLAYGROUND_CODE'), sortable: true, },
                { key: 'name', label: this.$t('PLAY_GROUND_NAME'), sortable: true, },
                { key: 'address', label: this.$t('ADDRESS'), sortable: true, },
                { key: 'status', label: this.$t('_LIST_USER.STATUS'), sortable: true, },
                { key: 'actions', label: this.$t('_LIST_USER.ACTION'), class: 'text-right' },
            ];
        },
        fieldsTbl() {
            return [
                { key: 'username', label: this.$t('_REGISTER.USERNAME') },
                { key: 'fullName', label: this.$t('_REGISTER.FULLNAME') },
                { key: 'email', label: this.$t('_REGISTER.EMAIL') },
                { key: 'createdDate', label: this.$t('_LIST_USER.CREATE_DATE'), class: 'text-right' },
                { key: 'active', label: this.$t('_LIST_USER.STATUS') },
                { key: 'actions', label: this.$t('_LIST_USER.ACTION'), class: 'text-right' },
            ];
        },
        sitesString() {
            let string = '';
            if (this.sites && this.sites.length > 0) {
                for (let i = 0; i < this.sites.length; i += 1) {
                    if (i < this.sites.length - 1) {
                        string += `${this.sites[i].hotelId},`;
                    } else {
                        string += this.sites[i].hotelId;
                    }
                }
                return string;
            } else {
                return '';
            }
        },
        hotelIdsString() {
            let string = '';
            if (this.hotels && this.hotels.length > 0) {
                for (let i = 0; i < this.hotels.length; i += 1) {
                    if (i < this.hotels.length - 1) {
                        string += `${this.hotels[i].hotelId},`;
                    } else {
                        string += this.hotels[i].hotelId;
                    }
                }
                return string;
            } else {
                return '';
            }
        },
    }
}